import React, { useState } from 'react';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    serviceType: 'stitching',
    message: ''
  });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Send via WhatsApp
    const message = `*New Inquiry from Website*\n\nName: ${formData.name}\nEmail: ${formData.email}\nService Type: ${formData.serviceType}\n\nMessage:\n${formData.message}`;
    const whatsappUrl = `https://wa.me/916392782674?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, '_blank');
    
    setSubmitted(true);
    setTimeout(() => {
      setSubmitted(false);
      setFormData({ name: '', email: '', serviceType: 'stitching', message: '' });
    }, 3000);
  };

  return (
    <div className="pt-20" data-testid="contact-page">
      {/* Hero Section */}
      <section className="relative h-[50vh] bg-cover bg-center" 
        style={{ backgroundImage: 'url(https://images.unsplash.com/photo-1739429946375-0a703857a86a?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920)' }}
      >
        <div className="absolute inset-0 bg-[#2B2B2B] bg-opacity-70"></div>
        <div className="relative h-full flex items-center justify-center text-center px-4">
          <div>
            <h1 className="font-playfair text-5xl sm:text-6xl lg:text-7xl text-[#F8F6F0] mb-4">
              Get In Touch
            </h1>
            <p className="font-montserrat text-lg text-[#D4AF37] tracking-widest">
              We'd Love To Hear From You
            </p>
          </div>
        </div>
      </section>

      {/* Contact Form & Info */}
      <section className="py-20 px-4 bg-[#F8F6F0]">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            {/* Contact Form */}
            <div className="bg-white p-8 rounded-lg shadow-lg" data-testid="contact-form-container">
              <h2 className="font-playfair text-4xl text-[#2B2B2B] mb-6">
                Send Us A Message
              </h2>
              
              {submitted && (
                <div 
                  className="bg-[#D4AF37] text-[#2B2B2B] p-4 rounded mb-6 font-montserrat text-sm"
                  data-testid="success-message"
                >
                  Thank you for contacting us! We'll get back to you soon.
                </div>
              )}

              <form onSubmit={handleSubmit} data-testid="contact-form">
                <div className="mb-6">
                  <label 
                    htmlFor="name" 
                    className="block font-montserrat text-sm text-[#2B2B2B] mb-2"
                  >
                    Name *
                  </label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-3 border border-[#D4AF37] focus:outline-none focus:ring-2 focus:ring-[#D4AF37] font-montserrat text-sm"
                    data-testid="name-input"
                  />
                </div>

                <div className="mb-6">
                  <label 
                    htmlFor="email" 
                    className="block font-montserrat text-sm text-[#2B2B2B] mb-2"
                  >
                    Email *
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-3 border border-[#D4AF37] focus:outline-none focus:ring-2 focus:ring-[#D4AF37] font-montserrat text-sm"
                    data-testid="email-input"
                  />
                </div>

                <div className="mb-6">
                  <label 
                    htmlFor="serviceType" 
                    className="block font-montserrat text-sm text-[#2B2B2B] mb-2"
                  >
                    Service Type *
                  </label>
                  <select
                    id="serviceType"
                    name="serviceType"
                    value={formData.serviceType}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-3 border border-[#D4AF37] focus:outline-none focus:ring-2 focus:ring-[#D4AF37] font-montserrat text-sm bg-white"
                    data-testid="service-type-select"
                  >
                    <option value="stitching">Stitching</option>
                    <option value="design">Design Consultation</option>
                    <option value="course">Course Inquiry</option>
                  </select>
                </div>

                <div className="mb-6">
                  <label 
                    htmlFor="message" 
                    className="block font-montserrat text-sm text-[#2B2B2B] mb-2"
                  >
                    Message *
                  </label>
                  <textarea
                    id="message"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    required
                    rows="6"
                    className="w-full px-4 py-3 border border-[#D4AF37] focus:outline-none focus:ring-2 focus:ring-[#D4AF37] font-montserrat text-sm resize-none"
                    data-testid="message-textarea"
                  ></textarea>
                </div>

                <button
                  type="submit"
                  className="w-full bg-[#D4AF37] text-[#2B2B2B] font-montserrat py-3 text-sm tracking-widest hover:bg-[#2B2B2B] hover:text-[#D4AF37] transition-colors duration-300"
                  data-testid="submit-button"
                >
                  SEND MESSAGE
                </button>
              </form>
            </div>

            {/* Contact Info */}
            <div>
              <h2 className="font-playfair text-4xl text-[#2B2B2B] mb-6">
                Contact Information
              </h2>
              
              <div className="space-y-6 mb-12">
                <div className="flex items-start">
                  <div className="w-12 h-12 bg-[#D4AF37] rounded-full flex items-center justify-center flex-shrink-0 mr-4">
                    <svg className="w-6 h-6 text-[#2B2B2B]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                    </svg>
                  </div>
                  <div>
                    <h3 className="font-montserrat text-lg text-[#2B2B2B] mb-1">Address</h3>
                    <p className="font-montserrat text-sm text-[#2B2B2B]">
                      Keshav Nagar, Juhi Kalan<br />
                      Saket Nagar, Kanpur<br />
                      Uttar Pradesh 208014, India
                    </p>
                  </div>
                </div>

                <div className="flex items-start">
                  <div className="w-12 h-12 bg-[#D4AF37] rounded-full flex items-center justify-center flex-shrink-0 mr-4">
                    <svg className="w-6 h-6 text-[#2B2B2B]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                    </svg>
                  </div>
                  <div>
                    <h3 className="font-montserrat text-lg text-[#2B2B2B] mb-1">Phone</h3>
                    <p className="font-montserrat text-sm text-[#2B2B2B]">
                      +91 6392782674<br />
                      Call or WhatsApp
                    </p>
                  </div>
                </div>

                <div className="flex items-start">
                  <div className="w-12 h-12 bg-[#D4AF37] rounded-full flex items-center justify-center flex-shrink-0 mr-4">
                    <svg className="w-6 h-6 text-[#2B2B2B]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                    </svg>
                  </div>
                  <div>
                    <h3 className="font-montserrat text-lg text-[#2B2B2B] mb-1">Email</h3>
                    <p className="font-montserrat text-sm text-[#2B2B2B]">
                      krystalapparelstore@gmail.com
                    </p>
                  </div>
                </div>

                <div className="flex items-start">
                  <div className="w-12 h-12 bg-[#D4AF37] rounded-full flex items-center justify-center flex-shrink-0 mr-4">
                    <svg className="w-6 h-6 text-[#2B2B2B]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                  </div>
                  <div>
                    <h3 className="font-montserrat text-lg text-[#2B2B2B] mb-1">Business Hours</h3>
                    <p className="font-montserrat text-sm text-[#2B2B2B]">
                      Monday - Saturday: 10:00 AM - 7:00 PM<br />
                      Sunday: By Appointment Only
                    </p>
                  </div>
                </div>
              </div>

              {/* Map Placeholder */}
              <div className="bg-white rounded-lg overflow-hidden shadow-lg h-64">
                <iframe 
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3570.6821886709644!2d80.28965!3d26.4850!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x399c47e1b88a6ffd%3A0x9f9d6c8c8c9c9c9c!2sKeshav%20Nagar%2C%20Juhi%20Kalan%2C%20Kanpur%2C%20Uttar%20Pradesh%20208014!5e0!3m2!1sen!2sin!4v1641234567890!5m2!1sen!2sin"
                  width="100%" 
                  height="100%" 
                  style={{ border: 0 }}
                  allowFullScreen="" 
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="Krystal Apparel Store Location"
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
